import { IPublicClientApplication } from "@azure/msal-browser";
import { IAuthenticateCommand } from "./OneDrivePicker";

export const combine = (...paths: string[]) => {
	return paths
		.map((path) => path.replace(/^[\\|/]/, "").replace(/[\\|/]$/, ""))
		.join("/")
		.replace(/\\/g, "/");
};

export const getToken = async (
	instance: IPublicClientApplication,
	command: IAuthenticateCommand,
): Promise<string | null> => {
	let accessToken = "";
	let authParams = null;

	switch (command.type) {
		case "SharePoint_SelfIssued":
			authParams = {
				scopes: [`${combine(command.resource, ".default")}`],
			};
			break;
		case "Upload":
			authParams = {
				scopes: ["User.Read", "Files.ReadWrite.All"],
			};
			break;
		default:
			authParams = {
				scopes: [],
			};
			break;
	}

	try {
		const responseIfLoggedIn = await instance.acquireTokenSilent(authParams);
		accessToken = responseIfLoggedIn.accessToken;
	} catch (e) {
		const responseAfterLogin = await instance.loginPopup(authParams);
		instance.setActiveAccount(responseAfterLogin.account);

		if (responseAfterLogin.idToken) {
			const responseToGetToken = await instance.acquireTokenSilent(authParams);

			accessToken = responseToGetToken.accessToken;
		}
	}

	return accessToken;
};
